import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function VerifyModal({
  enable2fa,
  history,
  isLoading,
  form,
  getProfile,
  handleSuccessModal,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);

  const handleOnChange = (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    enable2fa(formData, (profile) => {
      setModal({ isOpen: false });
      localStorage.setItem('status', 'enabled');
      getProfile(_.get(profile, 'data.id'));
      history.push('/profile');
      handleSuccessModal();
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <div className="content">
        <div className="login-box">
          <div>
            <p className="title-color">Enter confirmation code</p>
            <p className="history-color">
              Please enter the confirmation code that you see on your
              authentication app.
            </p>
          </div>
          <form onSubmit={handleOnSubmit}>
            <div className="col-6">
              <InputMask
                placeholder="Code"
                className="form-control code-container"
                maskChar=" "
                mask="999999"
                autoComplete="none"
                id="secret"
                name="secret"
                onChange={handleOnChange}
                value={_.get(formData, 'secret') || ''}
              />
            </div>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                onClick={closeModal}
                className="mt-3 btn btn-dark button-cancel"
              >
                <span className="font-weight-bold">Cancel</span>
              </button>
              <button
                type="submit"
                disabled={isLoading}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary  mt-3 ml-2 button-submit"
                style={{
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                }}
              >
                {isLoading && <i className="fas fa-spin fa-spinner" />}{' '}
                <span className="font-weight-bold">Submit</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal.Body>
  );
}

VerifyModal.defaultProps = {
  form: {},
};

VerifyModal.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  enable2fa: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  form: PropTypes.instanceOf(Object),
  getProfile: PropTypes.instanceOf(Function).isRequired,
  handleSuccessModal: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.ENABLE_2FA) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(VerifyModal);
